<h2 class="title">{{ title }}</h2>

<mat-dialog-content>
  <div class="form-container">
    <form [formGroup]="matchrunForm" (ngSubmit)="addCrossmatch()">
      <!-- Recipient Search -->
      <mat-form-field appearance="fill">
        <mat-label>Recipient</mat-label>
        <input type="text" matInput [readonly]="selectedRecipient" [matAutocomplete]="recipientAuto" [formControl]="recipientSearchControl" (input)="filterRecipients()" />
        <button type="button" mat-icon-button matSuffix *ngIf="selectedRecipient && !isFromMatchrun" (click)="clearRecipientSelection($event)">
          <mat-icon>clear</mat-icon>
        </button>
        <mat-autocomplete #recipientAuto="matAutocomplete" [displayWith]="displayRecipientName">
          <mat-option *ngFor="let recipient of filteredRecipients" [value]="recipient" (onSelectionChange)="selectRecipient(recipient)">
            {{ recipient.enisNumber }} - {{ recipient.firstName }} {{ recipient.lastName }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <!-- Donor Search -->
      <mat-form-field appearance="fill">
        <mat-label>Donor</mat-label>
        <input type="text" matInput [readonly]="selectedDonor" [matAutocomplete]="donorAuto" [formControl]="donorSearchControl" (input)="filterDonors()" />
        <button type="button" mat-icon-button matSuffix *ngIf="selectedDonor && !isFromMatchrun" (click)="clearDonorSelection($event)">
          <mat-icon>clear</mat-icon>
        </button>
        <mat-autocomplete #donorAuto="matAutocomplete" [displayWith]="displayDonorName">
          <mat-option *ngFor="let donor of filteredDonors" [value]="donor" (onSelectionChange)="selectDonor(donor)">{{ donor.enisNumber }} - {{ donor.firstName }} {{ donor.lastName }} </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Result date</mat-label>
        <input matInput [matDatepicker]="resultDatePicker" min="2020-01-01" formControlName="resultDate" placeholder="DD/MM/YYYY" />
        <mat-datepicker-toggle matSuffix [for]="resultDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #resultDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Sample date</mat-label>
        <input matInput [matDatepicker]="sampleDatePicker" min="2020-01-01" formControlName="sampleDate" placeholder="DD/MM/YYYY" />
        <mat-datepicker-toggle matSuffix [for]="sampleDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #sampleDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Comments</mat-label>
        <textarea matInput formControlName="comments" placeholder="Add any comments about this crossmatch..." rows="3"></textarea>
      </mat-form-field>

      <div class="button-container">
        <button mat-raised-button color="primary" type="submit" [disabled]="matchrunForm.invalid">Submit</button>
      </div>
    </form>
  </div>
</mat-dialog-content>
